@if (style !== 'chat') {
  <form [formGroup]="fG">
    @if (style === 'block' || style === 'inline') {
      <div class="{{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : ''}}">
        @if (richText) {
          <ejs-richtexteditor #textAreaElement
            [formControlName]="fCN"
            (keyup)="onReturnKeyPress($event)"
            (paste)="onPaste($event)"
            class="e-input"
            [attr.aria-placeholder]="placeholder"
            [toolbarSettings]="toolbarSettings"
            [enableXhtml]="true"
            [pasteCleanupSettings]="pasteCleanupSettings"
            [showCharCount]="showCharCounter"
            [maxLength]="maxChars ? maxChars : -1"
            [saveInterval]="1"
            [height]="height"
            [class]="class"
          ></ejs-richtexteditor>
        }
        @if (!richText) {
          <textarea #textAreaElement
            [formControlName]="fCN"
            [rows]="rows"
            (keyup)="onReturnKeyPress($event)"
            (paste)="onPaste($event)"
            class="e-input"
            [attr.aria-placeholder]="placeholder"
            [attr.maxlength]="maxChars ? maxChars : null">
          </textarea>
        }
        <span class="e-float-line"></span>
        <label [ngClass]="{'e-label-top': fG.controls[fCN].value !== '' && style === 'inline', 'e-label-bottom':  fG.controls[fCN].value === '' && style === 'inline'}"
        class="e-float-text">{{ placeholder }}</label>
      </div>
    }
    @if (style === 'headless') {
      @if (richText) {
        <ejs-richtexteditor #textAreaElement
          [formControlName]="fCN"
          (keyup)="onReturnKeyPress($event)"
          (paste)="onPaste($event)"
          class="e-input {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : ''}}"
          [placeholder]="placeholder"
          [attr.aria-placeholder]="placeholder"
          [toolbarSettings]="toolbarSettings"
          [enableXhtml]="true"
          [pasteCleanupSettings]="pasteCleanupSettings"
          [showCharCount]="showCharCounter"
          [maxLength]="maxChars ? maxChars : -1"
          [height]="height"
          [saveInterval]="1"
          [class]="class"
        ></ejs-richtexteditor>
      }
      @if (!richText) {
        <textarea #textAreaElement
          [formControlName]="fCN"
          [rows]="rows"
          (keyup)="onReturnKeyPress($event)"
          (paste)="onPaste($event)"
          class="e-input {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : ''}}"
          [placeholder]="placeholder"
          [attr.aria-placeholder]="placeholder"
        [attr.maxlength]="maxChars ? maxChars : null"></textarea>
      }
    }
    @if (errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty) {
      <div class="error-label" role="alert">
        {{ errorText }}
      </div>
    }
  </form>
}

@if (style === 'chat') {
  <form [formGroup]="fG" [class]="'d-flex flex-column flex-grow-1'">
    <textarea #textAreaElement [class]="class" [formControlName]="fCN" [placeholder]="placeholder" (keydown)="onReturnKeyPress($event)" (paste)="onPaste($event)"></textarea>
    @if (showCharCounter && maxChars > 0) {
      <div class="chat-char-counter text-end text-muted px-2 pb-1">
        {{ (fG.controls[fCN].value || '').length }} / {{ maxChars }}
      </div>
    }
  </form>
}
